
<template>
    <component :is="couponData === undefined ? 'div' : 'b-card'">

        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="couponData === undefined"
        >
            <h4 class="alert-heading">Error al obtener los datos del cupón de descuento</h4>
            <div class="alert-body">
                No se encontró ningún cupón con este id. Verificar en la
                <b-link
                    class="alert-link"
                    :to="{ name: 'coupons'}"
                >
                    Lista de cupones de descuento
                </b-link>
                para buscar otro cupón de descuento.
            </div>
        </b-alert>

        <coupon-edit-tab-information
            v-if="couponData"
            :coupon-data="couponData"
        />
    </component>
</template>

<script>

    import CouponEditTabInformation from './CouponEditTabInformation.vue';
    import {onUnmounted, ref} from '@vue/composition-api';
    import couponStoreModule from '../couponStoreModule';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            CouponEditTabInformation
        },
        setup() {
            const couponData = ref(null);

            const COUPON_APP_STORE_MODULE_NAME = 'app-coupon';

            // Register module
            if (!store.hasModule(COUPON_APP_STORE_MODULE_NAME)) store.registerModule(COUPON_APP_STORE_MODULE_NAME, couponStoreModule);

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(COUPON_APP_STORE_MODULE_NAME)) store.unregisterModule(COUPON_APP_STORE_MODULE_NAME)
            });

            store.dispatch('app-coupon/fetchCoupon', { id: router.currentRoute.params.id })
                .then(response => {
                    if (response.data === 'error') {
                        couponData.value = undefined
                    } else {
                        couponData.value = response.data;
                    }
                })
                .catch(error => {
                    if (error.response.status === 404) {
                        couponData.value = undefined
                    }
                });

            return {
                couponData
            }
        }
    }

</script>